import { Box, Grid } from "@material-ui/core";
import ModuleTabBox from "./ModuleTabBox";
const ListDevices = ({ devices, types }) => {
  const otherDevices = devices.filter(
    (device) => device?.water_meter_tag_info?.water_meter_tag_name === "سایر"
  );
  const moduleTypes = types.filter(
    (type) =>
      type.water_meter_tag?.water_meter_tag_id ===
      otherDevices[0]?.water_meter_tag_info?.water_meter_tag_id
  );
  return (
    <Grid container style={{ padding: "5px 16px" }}>
      <Box
        sx={{
          width: "100%",
          typography: "body1",
          background: "white",
        }}
        style={{
          boxShadow: "0 1px 1px 0 #999",
          borderRadius: "5px",
        }}
      >
        {/* <h3 style={{ padding: "0px 16px" }}>ماژول های پروژه</h3> */}
        {otherDevices.length > 0 ? (
          <ModuleTabBox types={moduleTypes} devices={otherDevices} />
        ) : (
          <div style={{ textAlign: "center", padding: "16px 0" }}>
            ماژولی موجود نیست
          </div>
        )}
      </Box>
    </Grid>
  );
};
export default ListDevices;
